import { useEffect, useState } from "react";

/**
 * Wall-clock time, refreshed once a minute (aligned to the minute boundary)
 * so relative labels — the calendar's today cell and now bar, the schedule
 * queue's "In 2h" — keep up while their view stays open.
 */
export function useNow(): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined;
    const msToNextMinute = 60_000 - (Date.now() % 60_000);
    const timeout = setTimeout(() => {
      setNow(new Date());
      interval = setInterval(() => setNow(new Date()), 60_000);
    }, msToNextMinute);
    return () => {
      clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, []);
  return now;
}
